var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.InvoiceAccess.Messages.Submit, Vendd.InvoiceAccess, function (envelope) {
        var options = {
            url: 'api/eInvoice/GetInvoiceCheckIfOrderExists',
            method: 'POST',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.InvoiceAccess, new Vendd.InvoiceAccess.Messages.SubmitSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.InvoiceAccess, new Vendd.InvoiceAccess.Messages.SubmitFailure(response));
        };

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});